<template>
  <div>
    <div class="work-list">
      <div v-for="item in listData" :key="item.value" class="work-box">
        <div class="work-main">
          <div class="work-title work-content">
            <p class="work-left">作业主题</p>
            <p>{{ item.topic | ellipsis }}</p>
          </div>
          <div class="work-content">
            <p class="work-left">状态</p>
            <p class="work-status">{{ item.answerStauts }}</p>
          </div>
          <div class="work-content">
            <p class="work-left">发布时间</p>
            <p>{{ item.startDate }}</p>
          </div>
          <div class="work-content">
            <p class="work-left">截止时间</p>
            <p>{{ item.endDate }}</p>
          </div>
          <div class="work-content">
            <p class="work-left">提交时间</p>
            <p>{{ item.answerSubmitDate }}</p>
          </div>
        </div>
        <div class="work-btn">
          <el-button
            size="small"
            type="primary"
            @click="goSubmit(item.homeworkId, item.answerId, '提交页面')"
            v-if="
              (item.answerStauts == '未提交' ||
                item.answerStauts == '被退回') &&
              item.isSubmit == '1'
            "
            >提交作业</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="goSubmit(item.homeworkId, item.answerId, '修改页面')"
            v-if="
              (item.answerStauts == '未提交' ||
                item.answerStauts == '被退回') &&
              item.isSubmit == '1'
            "
            >修改作业</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="goSubmited(item.homeworkId, item.answerId)"
            v-if="
              item.answerStauts == '已提交' || item.answerStauts == '已批阅'
            "
            >查看详情</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http } from "@/utils/axios";
import * as api from "@/api/homework/homework";
export default {
  name: "HomeworkTeacher",
  data() {
    return {
      totaldata: [{}, {}],
      query: {
        createUserid: localStorage.getItem("uid") || "36",
      },
      // 分页
      pageObj: {
        page: "1",
        pageSize: "20",
      },
      listData: {},
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 7) {
        return value.slice(0, 7) + "...";
      }
      return value;
    },
  },
  props: ["courseId", "courseType"],
  methods: {
    //获取作业列表
    getlist() {
      // const { courseId, courseType, createUserid }=this.query
      const { page, pageSize } = this.pageObj;
      let reqdata = {
        courseId: this.courseId,
        courseType: this.courseType,
        page: page,
        pageSize: pageSize,
        studentId: localStorage.getItem("uid") || "36",
      };
      api.getStudentHomeworkList(reqdata).then((res) => {
        const result = res;
        console.log(result.data.data.list);
        this.listData = result.data.data.list;
        this.listData.forEach((item) => {
          //状态转换
          if (
            item.answerStauts === 0 ||
            item.answerStauts === null ||
            item.answerStauts === ""
          ) {
            item.answerStauts = "未提交";
          } else if (item.answerStauts === 1) {
            item.answerStauts = "已提交";
          } else if (item.answerStauts === 2) {
            item.answerStauts = "已批阅";
          } else if (item.answerStauts === 3) {
            item.answerStauts = "被退回";
          }
          item.startDate = formatUtcTime(item.startDate);
          item.endDate = formatUtcTime(item.endDate);
        });
      });
    },
    // 跳转提交作业页面
    goSubmit(homeworkId, answerId, edit_style) {
      const url = "HomeworkSubmit";
      this.$router.push({
        name: url,
        query: {
          homeworkId: homeworkId,
          answerId: answerId,
          studentId: this.query.createUserid,
          edit_style: edit_style,
        },
      });
    },
    //跳转作业提交页面
    goSubmited(homeworkId, answerId) {
      const url = "HomeworkSubmited";
      this.$router.push({
        name: url,
        query: {
          homeworkId: homeworkId,
          answerId: answerId,
          studentId: this.query.createUserid,
        },
      });
    },
    //跳转修改作业页面
    goChange(homeworkId, answerId) {
      const url = "HomeworkSendback";
      this.$router.push({
        name: url,
        query: {
          homeworkId: homeworkId,
          answerId: answerId,
          studentId: this.query.createUserid,
        },
      });
    },
    //跳转已批阅作业页面
    goReaded() {
      const url = "HomeworkReaded";
      this.$router.push({ name: url, id: "123" });
    },
  },
  mounted() {
    this.getlist();
  },
};
function formatUtcTime(v) {
  if (!v) {
    return "";
  }
  let date = new Date(v);
  date = new Date(date.valueOf());
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) +
    "-" +
    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
    " " +
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
    ":" +
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":" +
    (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds())
  );
}
</script>

<style lang="scss" scoped>
.work-list {
  padding: 10px;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}
.work-box {
  width: 280px;
  padding: 10px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3490196);
  margin-right: 20px;
  flex-shrink: 0;
  margin-top: 20px;
}
.work-main {
  height: 125px;
}
.work-title {
  font-size: 16px;
  font-weight: 600;
}
.work-content {
  font-size: 14px;
  margin-bottom: 6px;
}
.work-title > p,
.work-content > p {
  display: inline-block;
}
.work-left {
  width: 80px;
  text-align: right;
  margin-right: 20px;
}
.work-status {
  color: #0099ff;
}
.work-btn {
  margin-top: 10px;
  text-align: center;
}
</style>
